<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item label="师傅姓名:" prop="name">
          <el-input
            clearable
            v-model.trim="table.params.name"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="师傅账号:" prop="account">
          <el-input
            clearable
            v-model.trim="table.params.account"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="工种类型:" prop="kinds_arr">
          <el-cascader
            style="width: 100%"
            ref="cascaderKinds"
            filterable
            clearable
            v-model="table.params.kinds_arr"
            :options="kindListOpt"
            @focus="getKindList"
            @change="onSearch"
            :props="{ value: 'id', label: 'name', checkStrictly: false }"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button
            class="theneBtn"
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
            >查询
          </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="curTableWrap" ref="main">
      <el-table
        :data="table.data"
        ref="tableDom"
        :height="tableHeight"
        border
        style="width: 100%"
        v-loading="table.loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        :header-cell-style="{ background: '#f5f5f5' }"
        class="chTable"
      >
        <el-table-column label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column label="师傅" prop="name" min-width="80">
        </el-table-column>
        <el-table-column label="账号" prop="account" min-width="120">
        </el-table-column>
        <el-table-column
          label="服务类型"
          prop="kind_arr"
          show-overflow-tooltip
          min-width="180"
        >
          <template slot-scope="{ row }">
            {{ row.kind_arr.map((item) => item.name).join("、") }}
          </template>
        </el-table-column>
        <el-table-column
          label="服务时间"
          prop="is_time"
          show-overflow-tooltip
          min-width="220"
        >
          <template slot-scope="{ row }">
            <span v-if="row.is_time == 2">不限时间</span>
            <span v-else>
              <span v-if="row.start_time == row.end_time">{{ row.start_time }}</span>
              <span v-else>{{ row.start_time }}至{{ row.end_time }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="期望报酬"
          prop="is_discuss"
          show-overflow-tooltip
          min-width="100"
        >
          <template slot-scope="{ row }">
            <!-- 是否议价 1:面议 2:支持议价 3:不议价 -->
            <div v-if="row.is_discuss == 3">
              <div v-if="Number(row.amount)">
                {{ row.amount }}元{{ row.amount_type_str ? "/" : ""
                }}{{ row.amount_type_str }}
              </div>
              <div style="font-size: 12px">不议价</div>
            </div>
            <div v-if="row.is_discuss == 2">
              <div v-if="Number(row.amount)">
                {{ row.amount }}元{{ row.amount_type_str ? "/" : ""
                }}{{ row.amount_type_str }}
              </div>
              <div style="font-size: 12px">可议价</div>
            </div>
            <div v-if="row.is_discuss == 1">
              <div v-if="Number(row.amount)">
                {{ row.amount }}元{{ row.amount_type_str ? "/" : ""
                }}{{ row.amount_type_str }}
              </div>
              <div style="font-size: 12px">面议</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="期望区域"
          prop="province_str"
          show-overflow-tooltip
          min-width="180"
        >
          <template slot-scope="{ row }">
            <span
              >{{ row.province_str }}{{ row.city_str
              }}{{
                row.area_arr.length
                  ? "(" + row.area_arr.map((item) => item.name).join("、") + ")"
                  : ""
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="服务介绍"
          prop="desc"
          show-overflow-tooltip
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          label="看过人数"
          prop="view_count"
          show-overflow-tooltip
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          label="求职状态"
          prop="is_show"
          show-overflow-tooltip
          min-width="80"
        >
          <template slot-scope="{ row }">
            {{{1:'公开',2:'隐藏',3:'过期'}[row.is_show]}}
          </template>
        </el-table-column>
        <el-table-column
          label="更新时间"
          prop="update_time"
          show-overflow-tooltip
          min-width="140"
        >
        </el-table-column>
        <el-table-column label="操作" prop="action" fixed="right" width="160">
          <template slot-scope="{ row }">
            <el-button type="text" @click="showDetail(row)">查看详情</el-button>
            <el-button type="text" @click="showMpDetail(row)"
              >查看名片</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination__wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="table.params.page"
          :page-size="table.params.count"
          :total="table.total"
          :page-sizes="[10, 20, 50, 100, 150]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <detailDialog ref="detailDialogRef"></detailDialog>
    <mpDialog ref="mpDialogRef"></mpDialog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import { mixinTableHeight } from "@/mixins/tableHeight.js";
import { mapGetters } from "vuex";
import detailDialog from "./components/detailDialog.vue";
import mpDialog from "./components/mpDialog.vue";
export default {
  name: "AreaList",
  components: {
    VTable,
    detailDialog,
    mpDialog,
  },
  mixins: [mixinTable, mixinTableHeight],
  computed: {
    ...mapGetters(["setKinds"]),
  },
  data() {
    return {
      table: {
        loading: false,
        params: {
          kinds_arr: [],
          name: "",
          account: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      showDrawer: true,
      kindListOpt: [],
    };
  },
  created() {
    this.getTable();
    this.getArea();
    this.getKindList();
  },
  methods: {
    getKindList() {
      this.$http.get("/admin/flex_kind/all", { params: {} }).then((res) => {
        if (res.code == 1) {
          this.kindListOpt = res.data;
        }
      });
    },
    getTable() {
      console.log(this.table.params,'this.table.params')
      let _params = { ...this.table.params };
      let [a='',b=''] = _params.kinds_arr;
      _params.kind_id = b;
      delete _params.kinds_arr;
      this.$http
        .get("/admin/flex_position/list", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.$nextTick(() => {
              this.$refs.tableDom.doLayout();
            });
          }
        });
    },

    // 查看
    showDetail(row) {
      let dom = this.$refs.detailDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
    showMpDetail(row) {
      let dom = this.$refs.mpDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
  },
};
</script>
<style scoped lang="scss">
.curTableWrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 24px;
  background: #fff;
  flex: 1;
  overflow: hidden;
}
.pagination__wrap {
  margin: 10px 0;
  text-align: right;
  padding-right: 40px;
}
</style>